import PropTypes from 'prop-types';

const ClampText = ({
  clamp,
  children,
  className,
  breakpoint, // Kept for contract, but no longer needed for logic
  truncationHTML, // See note below regarding this prop
  useNativeClamp, // Kept for contract, now effectively always true
  ...rest
}) => {
  // Determine if we should apply clamping
  const shouldClamp = clamp !== false && clamp !== 0;

  // Extract the numeric value for lines (handles both numbers and strings like "3")
  const clampLines = typeof clamp === 'number' ? clamp : parseInt(clamp, 10);

  // Apply the native CSS clamping styles if needed
  const clampStyle =
    shouldClamp && !isNaN(clampLines)
      ? {
          display: '-webkit-box',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: clampLines,
          overflow: 'hidden',
        }
      : {};

  return (
    <div className={className} style={clampStyle} {...rest}>
      {children}
    </div>
  );
};

ClampText.propTypes = {
  clamp: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]).isRequired,
  children: PropTypes.node.isRequired,
  breakpoint: PropTypes.number,
  className: PropTypes.string,
  truncationHTML: PropTypes.string,
  useNativeClamp: PropTypes.bool,
};

export default ClampText;
